import { AddressString } from '~components/providers/types';

import TestnetDeployement from '../../abi/TestnetDeployementOutput.json';
import {
  BalFarm,
  BoostedFarm,
  ELPType,
  ENativeAsset,
  EOtherAsset,
  EVestaAsset,
  FraxFarm,
  VestaFarm,
} from '../../types';

import { ContractAddresses } from '.';

export const arbitrumRinkebyContractConfig: ContractAddresses = {
  MultiCall: '0x5D6e06d3E154C5DBEC91317f0d04AE03AB49A273',
  [ENativeAsset.VSTA]: TestnetDeployement.VSTAToken.address as AddressString,
  [ENativeAsset.VST]: TestnetDeployement.VSTToken.address as AddressString,
  [ENativeAsset.bVSTA]: TestnetDeployement.VSTToken.address as AddressString,
  [EVestaAsset.wstETH]: '0x',
  [EVestaAsset.renBTC]: TestnetDeployement.renBTC.address as AddressString,
  [EVestaAsset.GMX]: TestnetDeployement.gOHM.address as AddressString,
  [EOtherAsset.vwGMX]: '0x',
  [EVestaAsset.DPX]: '0x',
  [EOtherAsset.vwDPX]: '0x',
  [EVestaAsset.sGLP]: '0x',
  [EVestaAsset.ETH]: '0x0000000000000000000000000000000000000000',
  [EOtherAsset.USDC]: '0x1e77ad77925ac0075cf61fb76ba35d884985019d',
  [EOtherAsset.DAI]: '0x1e77ad77925ac0075cf61fb76ba35d884985019d',
  [EOtherAsset.USDT]: '0x1e77ad77925ac0075cf61fb76ba35d884985019d',
  [EVestaAsset.gOHM]: TestnetDeployement.gOHM.address as AddressString,
  [EOtherAsset.FRAX]: TestnetDeployement.gOHM.address as AddressString,
  [EOtherAsset.FXS]: TestnetDeployement.gOHM.address as AddressString,
  [EOtherAsset.WETH]: TestnetDeployement.gOHM.address as AddressString,
  [EOtherAsset.fsGLP]: '0x',
  [ELPType['VSTA-ETH']]: '0x',
  [ELPType['VST-FRAX']]: '0x',
  [ELPType['VST-USDC']]: '0x',
  [ELPType['VST-USDC-DAI-USDT']]: '0x',
  [EOtherAsset.STAKED_4_POOL]: '0x',
  [EOtherAsset.BAL]: '0x',
  ActivePool: TestnetDeployement.activePool.address as AddressString,
  VaultManager: TestnetDeployement.troveManager.address as AddressString,
  MultiVaultGetter: TestnetDeployement.multiTroveGetter.address as AddressString,
  PriceFeed: TestnetDeployement.priceFeed.address as AddressString,
  SortedTroves: TestnetDeployement.sortedTroves.address as AddressString,
  StabilityPoolManager: TestnetDeployement.stabilityPoolManager.address as AddressString,
  ETHStabilityPool: '0x',
  renBTCStabilityPool: '0x',
  gOHMStabilityPool: '0x',
  DPXStabilityPool: '0x',
  GMXStabilityPool: '0x',
  GLPStabilityPool: '0x',
  ARBStabilityPool: '0x',
  wstETHStabilityPool: '0x',
  BorrowerOperations: TestnetDeployement.borrowerOperations.address as AddressString,
  CollateralSurplusPool: TestnetDeployement.collSurplusPool.address as AddressString,
  HintHelpers: TestnetDeployement.hintHelpers.address as AddressString,
  CommunityIssuance: TestnetDeployement.communityIssuance.address as AddressString,
  VestaParameters: TestnetDeployement.vestaParameters.address as AddressString,
  Whitelisting: '0x',
  VestaGMXBonusStaking: '0x',
  BalancerVault: '0x',
  VestingVesta: '0x',
  VestaNFT: '0x0EB423E9F52695E2073442342e3554c845BEa771',
  VestingV1: '0x',
  VestingV2: '0x',
  VestaGMXStaking: '0x',
  GMXFeeTracker: '0x',
  VestaGLPStaking: '0x',
  GLPFeeTracker: '0x',
  GLPManager: '0x',
  [BalFarm['VST-USDC-DAI-USDT']]: '0x',
  [VestaFarm['VSTA-ETH']]: '0x',
  [VestaFarm['VST-FRAX']]: '0x',
  [FraxFarm.VST_FRAX_GAUGE]: '0x',
  [BalFarm['V2-VST-USDC-DAI-USDT']]: '0x',
  VSTOracle: '0x',
  ChainlinkBAL: '0x',
  ChainlinkFXS: '0x',
  ChainlinkFRAX: '0x',
  ChainlinkUSDC: '0x',
  ChainlinkDAI: '0x',
  ChainlinkUSDT: '0x',
  VestaDexTrader: '0x',
  VestaInterestManager: '0x',
  ETHInterestRate: '0x',
  gOHMInterestRate: '0x',
  DPXInterestRate: '0x',
  GMXInterestRate: '0x',
  GLPInterestRate: '0x',
  ARBInterestRate: '0x',
  wstETHInterestRate: '0x',
  VestaSavingModule: '0x',
  SavingModuleStabilityPool: '0x',
  [EVestaAsset.ARB]: '0x',
  [ELPType['VST-USDC']]: '0x',
  [BoostedFarm['VST-USDC']]: '0x',
} as const;
